<template>
  <div class="string">
    <textInput
      class="input-field"
      :disabled="disabled"
      :label="label"
      :messages="message"
      :multiline="multiline"
      :placeholder="placeholder"
      :prefix="prefix"
      :prepend-inner-icon="icon"
      ref="input"
      :rules="validationRules"
      :value="value"
      :width="width"
      @change="[setConfigValue($event)]"
      validate-on-blur
    >
      <template
        v-if="!hideTooltip && !hideLabel && (!!tooltip || !!helpContent)"
        #append-label
      >
        <tooltip v-if="tooltip" :text="tooltip" />
        <helpIcon v-if="helpContent" :content="helpContent" />
      </template>
    </textInput>
    <template v-if="!hideTooltip && hideLabel && (!!tooltip || !!helpContent)">
      <tooltip v-if="tooltip" :text="tooltip" />
      <helpIcon v-if="helpContent" :content="helpContent" />
    </template>
  </div>
</template>

<script>
/**
 * @fileoverview Config input field for strings
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import fieldMap from "./field-map.json";
import getValidationRules from "@/util/getValidationRules";
import helpIcon from "@/components/help-icon";
import textInput from "@/qux-common/qux22/components/molecules/input";
import tooltip from "@/components/tooltip";

export default {
  name: "StringField",
  components: { helpIcon, textInput, tooltip },
  props: {
    category: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    helpContent: {
      type: String,
    },
    hideLabel: {
      type: Boolean,
    },
    hideTooltip: {
      type: Boolean,
    },
    icon: {
      type: String,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    message: {
      type: String,
    },
    multiline: {
      type: Boolean,
      default: false,
    },
    parentField: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    prefix: {
      type: String,
    },
    rules: {
      type: Array,
    },
    tooltip: {
      type: String,
    },
    value: {
      type: String,
    },
    width: {
      type: String,
    },
  },
  methods: {
    /**
     * Sets the value
     */
    setConfigValue(value) {
      this.$emit("setConfigValue", value.trim());
    },
    getFieldValue(value) {
      return (
        fieldMap[this.category] &&
        fieldMap[this.category][this.id] &&
        fieldMap[this.category][this.id][value]
      );
    },
    validate() {
      return this.$refs.input.validate();
    },
  },
  computed: {
    validationRules() {
      return getValidationRules({
        rules: this.rules,
        inputErrorMessage: this.getFieldValue("inputErrorMessage"),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.string {
  display: flex;
  gap: $qvo-spacing-8;
  .input-field {
    width: 100%;
  }
}
</style>